module.exports = __webpack_public_path__ + "img/block-graphs.00607d11.png";